import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/blogs')
      .then((res) => {
        setBlogs(res.data.items || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2B1810]">
      {/* Standardized Long-Width Panoramic Banner */}
      <section className="relative min-h-[220px] sm:min-h-[250px] lg:min-h-[270px] overflow-hidden border-b border-[#3A332E] flex items-end">
        <img
          src="/assets/blog_banner.jpg"
          alt="Ancient Sanskrit Vedic manuscripts, glowing diya lamp, and sandalwood prayer mala"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="relative mx-auto flex min-h-[220px] sm:min-h-[250px] lg:min-h-[270px] max-w-7xl items-end px-5 pb-7 sm:pb-8 pt-12 text-white w-full z-10">
          <div className="max-w-2xl space-y-1.5">
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.25em] text-[#C49A45] block">
              Sacred Wisdom & Articles
            </span>
            <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight text-white drop-shadow-md">
              The Chandana Chronicle
            </h1>
            <p className="max-w-xl text-xs sm:text-sm leading-relaxed text-[#EEE8E1] line-clamp-2 drop-shadow">
              Explore Vedic traditions, sacred temple rituals, genuine sandalwood care guides, and deep spiritual insights.
            </p>
          </div>
        </div>
      </section>

      {/* Main Blog Content Container */}
      <div className="max-w-6xl mx-auto px-4 py-12 space-y-10">

        {loading ? (
          <div className="py-20 text-center text-xs text-[#8A796C]">Loading blog posts...</div>
        ) : blogs.length === 0 ? (
          <div className="bg-white p-12 rounded-2xl border border-[#E8DFD8] text-center space-y-2">
            <h3 className="font-heading text-lg font-bold">No published blogs found</h3>
            <p className="text-xs text-[#8A796C]">Check back soon for new sandalwood articles!</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-8">
            {blogs.map((b) => (
              <Link
                key={b._id}
                to={`/blog/${b.slug}`}
                className="group bg-white border border-[#E8DFD8] hover:border-[#C49A45] rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col"
              >
                <div className="aspect-[16/10] bg-[#FAF8F5] overflow-hidden relative">
                  <img
                    src={b.image}
                    alt={b.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      e.target.src = '/assets/hero_perfect_ganesha.jpg';
                    }}
                  />
                  <span className="absolute top-3 left-3 bg-[#2B1810]/80 backdrop-blur-md text-[#C49A45] text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-full border border-[#C49A45]/40">
                    {b.category}
                  </span>
                </div>
                <div className="p-6 space-y-3 flex-1 flex flex-col justify-between">
                  <div className="space-y-2">
                    <div className="flex items-center justify-between text-[11px] text-[#8A796C]">
                      <span>{new Date(b.createdAt).toLocaleDateString()}</span>
                      <span>By {b.author}</span>
                    </div>
                    <h3 className="font-heading text-lg font-bold text-[#2B1810] group-hover:text-[#C49A45] transition-colors leading-snug line-clamp-2">
                      {b.title}
                    </h3>
                    <p className="text-xs text-[#8A796C] line-clamp-3 leading-relaxed">
                      {b.excerpt}
                    </p>
                  </div>

                  <div className="pt-3 border-t border-[#F5EFEB] flex items-center justify-between text-xs font-bold text-[#C49A45]">
                    <span>Read Full Article</span>
                    <span className="group-hover:translate-x-1 transition-transform">→</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
